import { Link } from "react-router-dom";
import { ARTICLES } from "../../../mocks/mockContent";
import Reveal from "../../../components/feature/Reveal";

const COLS = [
  { key: "明星动态", icon: "ri-user-star-line", desc: "艺人动态、新作官宣、圈内温暖瞬间", accent: "text-primary-600" },
  { key: "影视综艺", icon: "ri-movie-2-line", desc: "好剧好综口碑测评，追剧日历不错过", accent: "text-accent-700" },
  { key: "网络热梗", icon: "ri-chat-smile-3-line", desc: "流行语考古与观察，读懂这个时代的笑点", accent: "text-secondary-700" },
  { key: "热搜解读", icon: "ri-focus-3-line", desc: "把刷屏话题讲清楚，理性吃瓜的注脚", accent: "text-primary-700" },
];

export default function Columns() {
  return (
    <section aria-label="栏目直达" className="border-t hairline bg-background-100/60">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="text-center">
          <p className="text-sm font-semibold tracking-wide text-primary-700">按你感兴趣的来</p>
          <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">栏目直达</h2>
        </div>

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {COLS.map((c, i) => {
            const count = ARTICLES.filter((a) => a.category === c.key).length;
            return (
              <Reveal key={c.key} delay={i * 80}>
                <Link
                  to={`/rexun?cat=${encodeURIComponent(c.key)}`}
                  className="group flex h-full flex-col rounded-2xl border hairline bg-background-50 p-6 transition-all hover:-translate-y-1 hover:border-primary-300"
                >
                  <span className={`flex h-12 w-12 items-center justify-center rounded-xl bg-background-100 text-2xl ${c.accent}`}>
                    <i className={c.icon} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-4 font-display text-lg font-semibold text-foreground-950">{c.name}</h3>
                  <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{c.desc}</p>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="text-xs text-foreground-500">{count} 篇精选</span>
                    <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-background-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                      <i className="ri-arrow-right-line" aria-hidden="true"></i>
                    </span>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}